import { Texture, Vector4, Vector2, NearestFilter } from "three";

function createAminoacidTexture(aminoacidCodes, textCol) {
  const isHighRes = window.devicePixelRatio > 1.2;
  const multiplier = isHighRes ? 2 : 1;
  const fontSize = 13 * multiplier;
  const verticalOffset = 0;
  const letterBox = 32 * multiplier;
  const lettersPerSide = 8;
  const canvas = document.createElement("canvas");
  const side = letterBox * lettersPerSide;
  const ctx = canvas.getContext("2d");
  const offset = letterBox / 2;

  canvas.width = side;
  canvas.height = side;

  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.font = `${fontSize}px Arial`;

  const textureCoords = [];
  const textureCoordMap = {};
  const amino3 = Object.entries(aminoacidCodes);
  const amino1 = Object.entries(aminoacidCodes).map((x) => [x[0], x[0]]);
  const aminoacids = [...amino3, ...amino1];

  for (let i = 0; i < aminoacids.length; i++) {
    const col = Math.floor(i / lettersPerSide);
    const row = i % lettersPerSide;
    const x = row * letterBox + offset;
    const y = col * letterBox + offset + verticalOffset;
    const str = aminoacids[i][1];

    ctx.strokeStyle = textCol;
    ctx.fillStyle = textCol;

    ctx.fillText(str, x, y + verticalOffset);

    textureCoordMap[str] = textureCoords.length;
    textureCoords.push(
      new Vector4(
        row / lettersPerSide,
        col / lettersPerSide,
        1 / lettersPerSide,
        1 / lettersPerSide
      )
    );
  }

  const texture = new Texture(canvas);
  texture.flipY = false;
  texture.needsUpdate = true;
  texture.magFilter = NearestFilter;
  texture.minFiter = NearestFilter;
  canvas.remove();

  return {
    rectUv: [
      new Vector2(0, 0), // texture to point -> top left
      new Vector2(1, 0), // texture to point -> top right
      new Vector2(0, 1), // texture to point -> bottom right
      new Vector2(1, 1), // texture to point -> bottom left
    ],
    textureConf: { dir: 1 },
    texture,
    textureCoords,
    textureCoordMap,
  };
}

export default createAminoacidTexture;
